import { Box, Divider, SimpleGrid, Stack, Text } from '@mantine/core'
import { SectionCard } from '../layout/SectionCard'
import { FieldRenderer } from '../forms/FieldRenderer'
import { CollectionList } from './CollectionList'
import { getAtPath } from '../../utils/configPaths'
import classes from '../../styles/StudioEditorV2.module.css'

const wideTypes = new Set(['image', 'image-editor', 'rich-text', 'textarea', 'string-list', 'contact-list'])

export function CollectionEditor({
  section,
  collection,
  templateManifest,
  configuration,
  errors,
  updateValue,
  addAsset,
  addRenditionPreview,
  assetUrls,
  assetSourceUrls,
  selected,
  onSelect,
  onAdd,
  onRemove,
  onMove,
  onDuplicate,
}) {
  const items = getAtPath(configuration, collection.path, [])
  const index = Math.min(Math.max(Number(selected || 0), 0), Math.max(items.length - 1, 0))
  const item = items[index]
  if (!item) return null

  return (
    <SectionCard title={section.label} description={section.description}>
      <CollectionList
        collection={collection}
        items={items}
        selected={index}
        onSelect={onSelect}
        onAdd={onAdd}
        onRemove={onRemove}
        onMove={onMove}
        onDuplicate={onDuplicate}
      />
      <Divider />
      <Stack gap="md">
        {(collection.itemSections || []).map((itemSection) => (
          <Box key={itemSection.id}>
            <Text size="xs" fw={750} tt="uppercase" c="dimmed" mb="xs">{itemSection.label}</Text>
            {itemSection.description && <Text size="xs" c="dimmed" mb="xs">{itemSection.description}</Text>}
            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="sm">
              {(itemSection.fields || []).map((field) => {
                const path = `${collection.path}.${index}.${field.path}`
                return (
                  <Box key={field.path} className={(field.wide || wideTypes.has(field.type)) ? classes.fullField : undefined}>
                    <FieldRenderer
                      field={field}
                      templateManifest={templateManifest}
                      configuration={configuration}
                      basePath={`${collection.path}.${index}`}
                      item={item}
                      error={errors[path] || errors[`${collection.path}.${index}`]}
                      onChange={updateValue}
                      addAsset={addAsset}
                      addRenditionPreview={addRenditionPreview}
                      assetUrls={assetUrls}
                      assetSourceUrls={assetSourceUrls}
                    />
                  </Box>
                )
              })}
            </SimpleGrid>
          </Box>
        ))}
      </Stack>
    </SectionCard>
  )
}
/* Generic Schema V2 collection editor. */
